import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import { login, logout } from "../../redux/actions/session";

import logo from "../../assets/images/logo-trucoxo.png";
import pix18 from "../../assets/images/pix18.png";

import "./Login.scss";

const Login = () => {
  const token = useSelector((state) => state.session.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !password) {
      return toast.error("Por favor, preencha todos os campos.");
    }
    dispatch(login(email, password));
  };

  if (token) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-card__brand">
            <img src={logo} alt="Truco XP" />
          </div>
          <h1 className="login-card__title">Bem-vindo de volta!</h1>
          <button
            type="button"
            className="login-submit"
            onClick={() => dispatch(logout())}
          >
            Sair da conta
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <button
        type="button"
        className="login-page__close"
        onClick={() => navigate("/")}
        aria-label="Fechar"
      >
        <i className="fa-solid fa-xmark" /> Fechar
      </button>

      <form className="login-card" onSubmit={handleSubmit} noValidate>
        <div className="login-card__brand">
          <img src={logo} alt="Truco XP" />
        </div>

        <header className="login-card__header">
          <h1>Entre ou crie sua conta</h1>
          <p>Aposte, jogue e ganhe pontos</p>
        </header>

        <label className="login-field">
          <span className="login-field__label">E-mail</span>
          <input
            type="email"
            className="login-field__input"
            placeholder="Digite seu e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
        </label>

        <label className="login-field">
          <span className="login-field__label">Senha</span>
          <div className="login-field__input-wrap">
            <input
              type={showPassword ? "text" : "password"}
              className="login-field__input"
              placeholder="Digite sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <button
              type="button"
              className="login-field__toggle"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
            >
              <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
            </button>
          </div>
        </label>

        <Link to="/esqueci-senha" className="login-card__forgot">
          Esqueci minha senha
        </Link>

        <button type="submit" className="login-submit">
          Acessar
        </button>

        <Link to="/new-account" className="login-card__signup-link">
          Criar minha conta
        </Link>

        <div className="login-card__payment">
          <img src={pix18} alt="Pix · 18+" />
          <p>Depósitos e saques em menos de 10 segundos via Pix</p>
        </div>
      </form>

      <footer className="login-page__footer">
        <span>trucoxp©</span>
        <span>{new Date().getFullYear()}</span>
      </footer>
    </div>
  );
};

export default Login;
